@import '@alfalab/core-components-vars/src/index.css';
@import '../../input/src/components/base-input/default.module.css';
@import '../../form-control/src/vars.css';

.textarea {
    color: var(--input-color);
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.textarea::placeholder {
    color: var(--input-placeholder-color);
}

.hasInnerLabel::placeholder {
    color: var(--input-with-label-placeholder-color);
}

/* DISABLED STATE */

.textarea:disabled {
    color: var(--input-disabled-color);
    -webkit-text-fill-color: var(--input-disabled-color);
}

/* READ-ONLY STATE */

.textarea:read-only {
    color: var(--input-read-only-color);
}

/* FOCUS STATE */

.textarea:focus::placeholder {
    color: var(--input-focus-placeholder-color);
}

.hint {
    color: var(--form-control-hint-color);
}

.error {
    color: var(--form-control-error-color);
}
